import { store } from '../../../../store/store';
import ktCommon from './ktCommon';
import cstaKtDefs from './cstaKtDefs';
import apiEvent from '@/util/call/apiEvent';
import eventBus from '@/EventBus';
import logReport from '@/util/logReport';

let callInfo = {
  brandDnis: '',
  callbackId: '',
  callbackType: '',
  callEvent: '',
  channelUniqueKey: '',
  contactTypeId: '',
  direction: '',
  dnis: '',
  endTime: '',
  incomingChannel: '',
  isAnonymous: false,
  isCallEnd: false,
  isCleared: false,
  isClose: false,
  isOriginatedEnd: false,
  isSummaryCompleted: true,
  memo: '',
  recordNo: '',
  serviceCode: '',
  startTime: '',
  tagList: [],
  taskData: {},
  ticketId: null,
  ticketStatus: '',
  userKey: ''
};

let agentCode = null;
let webSocket = null;
let callEvent = null;
let direction = '';
let holdStatus = false;
let outBoundCall = null;
let isSpyCall = false;

function getAgentCode() {
  return agentCode || store.getters.telNumber;
}

function getAgentId() {
  return store.getters.agentId;
}

function changeCallEvent(evtName) {
  callEvent = evtName;
  store.commit('changeCallEvent', evtName);
}

/**
 * WebSocket 서버에 연결 하기
 * @ktStartMonitor
 * @param {string} serverIp - WebSocket 서버 주소
 * @param {string} serverPort - WebSocket 서버 포트
 * @param {string} userId - Login할 전화(내선)번호
 * @param {object} handler - WebSocket 이벤트 콜백 객체
 * @returns {boolean} - 성공: true, 실패: false
 */

function ktStartMonitor() {
  callEvent = store.getters.callInfo.callEvent;
  direction = store.getters.callInfo.direction;
  store.commit('setChannelUniqueKey', store.getters.callInfo.channelUniqueKey);
  store.commit('changeIsTelIng', true);
  store.commit('changeIsValidTel', true);
  store.commit('initDimmed');
  store.commit('LOGIN_CALL');
  let values = {
    action: 'Ping'
  };

  changeCallEvent('startMonitor');
  logReport.write('[START-MONITOR] [CHANGE-CALL-EVENT] startMonitor');

  let intervalObj = setInterval(() => {
    if (store.getters.IS_TEL_ING === false) {
      clearInterval(intervalObj);
      return false;
    }
    if (store.getters.pingTryCount < 5) {
      if (store.getters.pingTryCount > 2) {
        logReport.write(`[WARRING] - 네트워크 지연... ${store.getters.pingTryCount * 2500}ms`);
      }

      store.commit('increasePingTryCnt');
      sendMessage(values);
    } else {
      clearInterval(intervalObj);
      setTimeout(() => {
        eventBus.$emit('call-reconnect-start');
      }, 3000);
    }
  }, 2500);
}

/**
 * WebSocket 연결 해제 하기
 * ktDisconnect
 * @returns {boolean} - 성공: true, 실패: false
 */
function ktDisconnect() {
  if (webSocket !== null) {
    webSocket.close();
    webSocket = null;
  }
}

/**
 * 외부 전화 걸기
 * ktExternalCall
 * @param {string} callnumber - 전화할 상대 외부 전화번호
 * @returns {boolean} - 성공: true, 실패: false
 */
function ktExternalCall(callnumber, serviceNumber) {
  outBoundCall = callnumber;
  changeCallEvent('Originate');
  logReport.write(`[EXTERNAL-CALL] [CHANGE-CALL-EVENT] Originate callnumber: ${callnumber}, serviceNumber: ${serviceNumber}`);
  const rid = serviceNumber.split('-').join('');
  let values = {
    action: 'Originate',
    dial_number: callnumber,
    rid_number: rid,
    rid_type: '3'
  };
  store.commit('changeDnis', rid);
  store.commit('changeCurrentCallBrand', { dnis: rid });
  return sendMessage(values);
}

/**
 * 내부 전화 걸기
 * ktInternalCall
 * @param {string} callnumber - 전화할 상대 외부 전화번호
 * @returns {boolean} - 성공: true, 실패: false
 */
function ktInternalCall(callnumber) {
  let values = {
    action: 'Originate',
    dial_number: callnumber
  };

  return sendMessage(values);
}

/**
 * 전화 받기
 * ktAnswer
 * @param {string} callnumber - 전화할 상대 외부 전화번호
 * @returns {boolean} - 성공: true, 실패: false
 */
function ktAnswer() {
  let values = {
    action: 'Answer'
  };

  logReport.write('[ANSWER]');
  return sendMessage(values);
}

/**
 * 통화 보류
 * ktHold
 * @param {boolean} hold - true: 통화보류, false: 통화 보류 해제
 * @returns {boolean} - 성공: true, 실패: false
 */
function ktHold(hold) {
  holdStatus = hold;
  let values = {
    action: 'HoldAudio',
    option: holdStatus ? 'on' : 'off'
  };

  logReport.write('[HOLD]');
  return sendMessage(values);
}
/**
 * 음소거
 * ktMute
 * @param {boolean} hold - true: 음소거, false: 음소거 해제
 * @returns {boolean} - 성공: true, 실패: false
 */
function ktMute(mute) {
  const agtCode = getAgentCode();
  let command = null;
  if (mute) {
    command = 'MuteAudio ' + agtCode + ' on';
  } else {
    command = 'MuteAudio ' + agtCode + ' off';
  }
  return sendMessage(command);
}

/**
 * 통화 당겨받기
 * ktPickup
 * @returns {boolean} - 성공: true, 실패: false
 */
function ktPickup() {
  let values = {
    action: 'PickupCall'
  };

  return sendMessage(values);
}

/**
 * 통화 전달하기
 * ktTransfer
 * @param {string} type - 'a': 협의 전달, 'b': 직접전달
 * @param {string} callnumber - 전달할 상대 전화번호
 * @returns {boolean} - 성공: true, 실패: false
 */
function ktTransfer(type, callnumber) {
  var command = type === 'a' ? 'Atxfer' : 'Blindxfer';

  let values = {
    action: command,
    trans_number: callnumber,
    context: 'transfer_call'
  };
  logReport.write(`[TRANSFER] [CHANGE-CALL-EVENT] trans_number: ${callnumber}`);
  changeCallEvent('transfer');

  return sendMessage(values);
}

function ktTransferCancel() {
  let values = {
    action: 'Hangup',
    option: '2'
  };

  logReport.write('[TRANSFER-CANCEL]');
  return sendMessage(values);
}
/**
 * 에이전트 상태 변경하기
 * ktAgentStatus
 * @param {string} status - 상태 변경 값
 * @returns {boolean} - 성공: true, 실패: false
 */
function ktAgentStatus(AgtMode, subStatus) {
  if (!AgtMode && !subStatus) return false;
  if (AgtMode === cstaKtDefs.AgentMode.AM_LOG_IN && ktCommon.IS_CHANGE_STATUS) {
    ktCommon.IS_CHANGE_STATUS = false;
  } else if (AgtMode === cstaKtDefs.AgentMode.AM_WORK_NOT_READY) {
    ktCommon.IS_CHANGE_STATUS = false;
  }

  if (ktCommon.IS_CHANGE_STATUS) {
    setTimeout((AgtMode, subStatus) => {
      ktAgentStatus(AgtMode, subStatus);
    }, 500);
    return false;
  }

  let status = 0;
  if (!isNaN(AgtMode)) {
    if (subStatus) {
      const mode = `${AgtMode}_${subStatus}`;
      status = String(cstaKtDefs.NumberAgentMode[mode] || mode);
    } else {
      status = String(cstaKtDefs.AgentMode[AgtMode] || AgtMode);
    }
  } else {
    status = String(cstaKtDefs.AgentMode[AgtMode]);
  }

  ktCommon.IS_CHANGE_STATUS = true;
  if (AgtMode < 0 || AgtMode > 18) {
    return false;
  }
  let values = {
    action: 'SetAgentState',
    option: status
  };

  logReport.write(`[AGENT-STATUS] status: ${status}`);
  return sendMessage(values);
}

/**
 * 전화상태 확인하기
 * ktCallStatus
 * @param {string} callnumber - 상태확인 전화번호(옵션)
 * @returns {boolean} - 성공: true, 실패: false
 */
function ktCallStatus() {
  let values = {
    action: 'GetAgentState',
    option: 2
  };

  return sendMessage(values);
}

/**
 * 통화를 직접 컨트롤 하기
 * ktSpyCall
 * @param {string} callnumber - 컨트롤 전화번호 (내선번호)
 * @param {string} option - 컨트롤 타입(감청하기 'b', 코칭하기 'w')
 * @returns {boolean} - 성공: true, 실패: false
 */
function ktSpyCall(callnumber, option) {
  changeCallEvent('spyCall');
  let values = {
    action: 'SpyCall',
    target_number: callnumber,
    option: option
  };

  return sendMessage(values);
}

/**
 * 통화 끊기
 * ktHangup
 * @returns {boolean} - 성공: true, 실패: false
 */
function ktHangup() {
  let values = {
    action: 'Hangup',
    option: 1
  };

  logReport.write('[HANG-UP]');
  return sendMessage(values);
}

/**
 * 웹소켓 메세지 발송
 * sendMessage
 * @param {string} message - WebSocket에 메세지 전송
 * @returns {boolean} - 성공: true, 실패: false
 */
function sendMessage(msg) {
  let result = true;
  const message = msg.action ? Object.assign(msg, { extension: getAgentCode() }) : msg;

  try {
    store.dispatch('sendMessageToCallSocket', message ? JSON.stringify(message) : null);
  } catch (e) {
    console.log('send error : ' + e);
    return !result;
  }
  return result;
}

function doHangup() {
  const callStatus = localStorage.getItem('call-agent-status');
  if (JSON.parse(callStatus).status !== '통화중') {
    return;
  }

  apiEvent.buttonState(cstaKtDefs.STATE_NREADY);
  store.commit('setIsTransferCancel', false);
  store.commit('changeServiceCode', '');
  eventBus.$emit('call-connection', 'cleared');
  eventBus.$emit('call-work-not-ready');
  window.sessionStorage.clear();
}

// add 20210720 Event 처리
function EventProc(rcvData) {
  if (!rcvData) return;
  const { event, data, response } = rcvData;

  if (event) {
    switch (event) {
      case 'SetAgentStateAction':
        logReport.write(`[SET-AGENT-STATE-ACTION] status: ${data.STATUS}, callEvent: ${callEvent}`);
        logReport.write(`[SET-AGENT-STATE-ACTION] direction: ${direction}, callInfo.direction: ${store.getters.callInfo.direction}`);
        ktCommon.IS_CHANGE_STATUS = false;
        let status = String(data.STATUS);
        if (response === 'Success' && status !== 'undefined') {
          // 통계 server에 I/O 구분값 보내주는 부분
          if ((status === '3') | (status === '8')) {
            const directionState = direction || store.getters.callInfo.direction || 'I';
            store.dispatch('send_status', { agentId: getAgentId(), data: { status, ioType: directionState } });
            logReport.write(`[SEND-STATUS] status: ${status}, ioType: ${directionState}`);
          } else if (status === '4') {
            store.dispatch('send_status', { agentId: getAgentId(), data: { status, ioType: 'O' } });
            logReport.write(`[SEND-STATUS] status: ${status}, ioType: 'O'`);
          } else if (status) {
            store.dispatch('send_status', { agentId: getAgentId(), data: { status } });
            logReport.write(`[SEND-STATUS] status: ${status}`);
          }

          // IB/OB 일때 후처리 이벤트 받을 때 통화 종료 처리
          if (status === '7') {
            if (callEvent === 'OriginateAction' || callEvent === 'AnswerAction') {
              logReport.write('[EVENT-PROCESS] [CHANGE-CALL-EVENT] Hangup');
              changeCallEvent('Hangup');
              doHangup();
            }
          }
        }

        if (callEvent === 'startMonitor') {
          let localStorageCallEvent = null;
          try {
            localStorageCallEvent = JSON.parse(localStorage.getItem('call-info')).callEvent;
          } catch (e) {
            console.log(e);
          }
          logReport.write(`[localStorageCallEvent]: ${localStorageCallEvent}`);
          changeCallEvent(localStorageCallEvent && localStorageCallEvent !== 'startMonitor' ? localStorageCallEvent : null);
          sendMessage({ action: 'Ping' });
        }
        break;
      case 'Ringing':
        const callType = rcvData.calltype || 0;

        logReport.write(`[Ringing] callType: ${callType}, isSpyCall: ${isSpyCall}, outBoundCall: ${outBoundCall}, data: ${data}`);

        window.sessionStorage.setItem('isCall', Date.now());
        eventBus.$emit('call-connection', 'originated');
        if (data) {
          if (isSpyCall) return;

          let serviceCode = '';
          let channelUniqueVal = '';
          const dataObject = JSON.parse(data);

          ktAgentStatus(cstaKtDefs.AgentMode.AM_WORK_RINGING);

          // IB일 때
          if (callEvent !== 'OriginateAction') {
            serviceCode = dataObject.queue_enc_name || dataObject.queue_name;
          }
          channelUniqueVal = dataObject.unique_id;
          callInfo.channelUniqueKey = channelUniqueVal;
          store.commit('setChannelUniqueKey', channelUniqueVal);

          if (dataObject.type && dataObject.type === 'transfer') {
            store.commit('setIsTransferCancel', true);
            changeCallEvent('transfer');
          }

          callInfo.serviceCode = serviceCode || '';
          store.commit('changeServiceCode', serviceCode);

          logReport.write(`[RINGING] serviceCode: ${serviceCode}, channelUniqueVal: ${channelUniqueVal}`);
        }

        if (callType === '1' || callType === '4') {
          const tempDrc = 'I';
          store.commit('changeDirection', tempDrc);
          direction = tempDrc;

          apiEvent.buttonState(cstaKtDefs.STATE_DELIVERED_RECV);
          store.commit('changeCallUserKey', JSON.parse(data).cid);
          eventBus.$emit('call-bound:in', JSON.parse(data));
        } else if (callType === '2') {
          apiEvent.buttonState(cstaKtDefs.STATE_DELIVERED_SEND);
          store.commit('changeCallUserKey', outBoundCall || 'notdefined');
          // IP 전화기로 직접 걸었을 때..
          if (!outBoundCall) {
            changeCallEvent('OriginateAction');
            direction = 'O';
            store.commit('changeDirection', 'O');
          }
          eventBus.$emit('call-bound:out', JSON.parse(data));
          outBoundCall = null;
        }
        logReport.write(`[RINGING] direction: ${direction}`);
        break;
      case 'AnswerAction':
        logReport.write(`[ANSWER-ACTION] callEvent: ${callEvent}, response: ${response}`);
        if (response === 'Success') {
          if (callEvent !== 'spyCall') {
            apiEvent.buttonState(cstaKtDefs.STATE_ESTABLISHED);
          }
          if (callEvent !== 'spyCall' && callEvent !== 'transfer') {
            changeCallEvent('AnswerAction');
          }
          store.commit('changeStartTime', new Date().getTime());
        }
        break;
      case 'OriginateAction':
        logReport.write(`[ORIGINATE-ACTION] response: ${response}`);
        if (response === 'Success') {
          changeCallEvent('OriginateAction');
          const tempDrc = 'O';
          store.commit('changeDirection', tempDrc);
          direction = tempDrc;
          ktAgentStatus(cstaKtDefs.AgentMode.AM_CALL);
        }
        break;
      case 'Bridge':
        logReport.write(`[BRIDGE] holdStatus: ${holdStatus}, data: ${data}`);
        logReport.write(`[BRIDGE] isCustomerPhoneNumberNaN: ${isNaN(store.getters.customerPhoneNumber)}, callEvent: ${callEvent}`);
        if (!holdStatus) {
          apiEvent.buttonState(cstaKtDefs.STATE_ESTABLISHED);
        }
        const jsonData = JSON.parse(data);

        if (isNaN(store.getters.customerPhoneNumber)) {
          const { rid } = jsonData;
          callInfo.dnis = rid;
          store.commit('changeDnis', rid);
          store.commit('changeCurrentCallBrand', { dnis: rid });
          store.dispatch('changeCallUserKey', jsonData['record_file'].split('_')[3]);
        }

        switch (callEvent) {
          case 'AnswerAction':
            callInfo.userKey = jsonData.cid;
            store.commit('changeRecordNo', jsonData['record_file']);
            logReport.write(`[BRIDGE-INFO] callEvent: ${callEvent}, callInfo.userKey: ${callInfo.userKey}, record: ${jsonData['record_file']}`);
            break;
          case 'OriginateAction':
            const { cid, rid } = jsonData;
            callInfo.userKey = cid;
            callInfo.brandDnis = rid;
            callInfo.dnis = rid;
            callInfo.recordNo = jsonData['record_file'];
            store.commit('changeStartTime', new Date().getTime());
            store.commit('changeBrandDnis', rid);
            store.commit('changeRecordNo', jsonData['record_file']);
            logReport.write(
              `[BRIDGE-INFO] callEvent: ${callEvent}, callInfo.userKey: ${callInfo.userKey}, callInfo.dnis: ${callInfo.dnis}, record: ${jsonData['record_file']}`
            );
            break;
        }
        break;
      case 'TransferBridge':
        logReport.write(`[TRANSFER-BRIDGE]`);
        changeCallEvent('TransferBridge');
        apiEvent.endCall();
        eventBus.$emit('call-work-not-ready');
        eventBus.$emit('hidePopup', 'showTransferPopup');
        break;
      case 'HoldAudioAction':
        logReport.write(`[HOLD-AUDIO-ACTION] response: ${response}, data: ${data}}`);
        if (response === 'Success') {
          if (data === 'on') {
            apiEvent.buttonState(cstaKtDefs.STATE_HOLD);
          } else {
            apiEvent.buttonState(cstaKtDefs.STATE_ESTABLISHED);
          }
        }
        break;
      case 'Hangup':
        logReport.write(`[HANG-UP] callEvent: ${callEvent}`);
        if (callEvent === 'Hangup') {
          eventBus.$emit('call-work-not-ready');
          changeCallEvent(null);
          direction = '';
        }
        if (callEvent === 'transfer') {
          // 220426 이관받은 상담사 통화 종료 시 상태 변경 및 후처리 상태 세팅
          store.dispatch('send_status', { agentId: getAgentId(), data: { status: '7' } });
          changeCallEvent('Hangup');
        }
        doHangup();
        break;
      case 'HangupAction':
        logReport.write(`[HANG-UP-ACTION] callEvent: ${callEvent}`);
        if (callEvent === 'spyCall') {
          apiEvent.setAgentState('AM_LOG_IN');
          store.commit('changeCallAgentStatus', '상담준비');
          store.commit('changeIsSummaryCompleted', true);
          apiEvent.buttonState(cstaKtDefs.AM_LOG_IN);
          changeCallEvent(null);
          isSpyCall = false;
          store.commit('changeIsSpying', false);
        } else if (callEvent === 'transfer') {
          changeCallEvent('transfer');
        } else {
          const callStatus = localStorage.getItem('call-agent-status');
          if (JSON.parse(callStatus).status === '통화중') {
            store.dispatch('send_status', { agentId: getAgentId(), data: { status: '7' } }); // 웹소켓이 끊겼다가 재연결 될 경우, setAgentStateAction 이벤트를 받지 못하는 경우가 발생하여 추가.
            doHangup();
          }
        }
        break;
      case 'SpyCallAction':
        isSpyCall = rcvData.response === 'Success';
        logReport.write(`[SPY-CALL-ACTION] isSpyCall: ${isSpyCall}`);
        store.commit('changeIsSpying', true);
        break;
      case 'SpyStart':
        logReport.write(`[SPY-START] isSpyCall: ${isSpyCall}`);
        if (isSpyCall) {
          ktAnswer();
        }
        break;
      case 'PingAction':
        if (response === 'Success') {
          store.commit('resetPingTryCnt');
        }
        break;
    }
  }
  localStorage.setItem('call-details-info', JSON.stringify(callInfo));
}

function initCallID() {
  callInfo.callId = 0;
  callInfo.evt = 0;
  callInfo.called_dn = '';
  callInfo.called_dn = '';
  callInfo.redirection_dn = '';
  callInfo.userInfo = '';
  callInfo.holdingdn = '';
  callInfo.localconnstate = 0;
  callInfo.eventcause = 0;
}

function setCallInfo(newVal) {
  callInfo = newVal;
}

export default {
  ktStartMonitor,
  ktDisconnect,
  ktExternalCall,
  ktInternalCall,
  ktAnswer,
  ktHold,
  ktMute,
  ktPickup,
  ktTransfer,
  ktTransferCancel,
  ktAgentStatus,
  ktCallStatus,
  ktSpyCall,
  ktHangup,
  EventProc,
  initCallID,
  setCallInfo
};



// WEBPACK FOOTER //
// ./src/util/call/kt/ktAPI/ktAPI.js